export const featureFlag = {
  apple_wallet: false,
} as const;
